import ReactDOM from 'react-dom/client';

import '@fontsource-variable/inter';

import App from './App.tsx';
import { restoreAppearance } from './appearance/appearance.ts';
import { recordError } from './core/errorLog.ts';
import './core/i18n/index.ts';
import { restorePreview } from './experiments/colorsPreview.ts';
import './index.css';
import { startSelectionOnPress } from './utils/selectionDrag.ts';
import { readIsDarkMode } from './utils/useDarkMode.tsx';

// Errors nothing caught, for the error log a reported problem sends along (plan task 98).
window.addEventListener('error', (event) => recordError(event.error));
window.addEventListener('unhandledrejection', (event) => recordError(event.reason));
// Captured, since react-aria's pressables stop the press from reaching the document.
document.addEventListener('mousedown', startSelectionOnPress, true);

// Set before the first frame, so a page in the dark theme doesn't flash light.
document.documentElement.classList.toggle('dark', readIsDarkMode());
// The signed-in user's appearance as this browser last showed it (plan task 120), before the first frame too.
restoreAppearance(readIsDarkMode());
// A colour option tried on the whole app from experiments/colors, kept until it's reset there.
restorePreview();
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
